import { SITE, NAV_LINKS } from "@/data/content";
import { useSmoothScroll } from "./useSmoothScroll";

export default function Footer() {
  const scrollTo = useSmoothScroll();
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/[0.06] py-16 md:py-24">
      <div className="max-w-[88rem] mx-auto px-6 md:px-10">
        <div className="grid sm:grid-cols-2 lg:grid-cols-12 gap-12 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-5">
            <p className="font-display text-3xl md:text-4xl font-bold tracking-[0.1em] text-zinc-50" data-testid="footer-logo">
              {SITE.name} <span className="text-gold text-xl md:text-2xl tracking-[0.2em]">— BY {SITE.owner.toUpperCase()}</span>
            </p>
            <p className="mt-4 font-mono text-xs uppercase tracking-[0.25em] text-gold" data-testid="footer-positioning">
              {SITE.positioning}
            </p>
            <p className="mt-3 font-mono text-xs uppercase tracking-[0.2em] text-zinc-500">
              {SITE.footerTagline}
            </p>
          </div>
          <div className="lg:col-span-2">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-600 mb-5">Creative Studio</p>
            <div className="flex flex-col gap-3">
              {["Video Editing", "Visual Design", "AI Creative"].map((s) => (
                <button
                  key={s}
                  data-testid={`footer-studio-${s.toLowerCase().replace(/\s/g, "-")}`}
                  onClick={() => scrollTo("#services")}
                  className="text-left text-sm text-zinc-400 hover:text-gold transition-colors duration-300 w-fit"
                >
                  {s}
                </button>
              ))}
            </div>
          </div>
          <div className="lg:col-span-2">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-600 mb-5">Explore</p>
            <nav className="flex flex-col gap-3" data-testid="footer-nav">
              {NAV_LINKS.map((l) => (
                <button
                  key={l.href}
                  data-testid={`footer-link-${l.label.toLowerCase()}`}
                  onClick={() => scrollTo(l.href)}
                  className="text-left text-sm text-zinc-400 hover:text-gold transition-colors duration-300 w-fit"
                >
                  {l.label}
                </button>
              ))}
            </nav>
          </div>
          <div className="lg:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-600 mb-5">Future</p>
            <span className="flex items-center gap-2.5 text-sm text-zinc-500 cursor-default" data-testid="footer-store-coming-soon">
              <span className="whitespace-nowrap">MARKMAXO Store</span>
              <span className="shrink-0 whitespace-nowrap rounded-full border border-gold/30 px-2.5 py-0.5 font-mono text-[9px] uppercase tracking-[0.2em] text-gold">
                Coming Soon
              </span>
            </span>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-white/[0.06] flex flex-col sm:flex-row justify-between gap-3">
          <p className="text-xs text-zinc-600 whitespace-nowrap">© 2026 {SITE.name}. All rights reserved.</p>
          <p className="text-xs text-zinc-600">Designed & built with a cinematic touch.</p>
        </div>
      </div>
    </footer>
  );
}
